/* istanbul ignore file */
import React from 'react';
import { CreateForm, FormTemplateProps, FormFieldsData } from 'framework/form';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import useEmployeeFeedbackService from 'domain/people/employee/Timeline/feedback/employeeFeedbackService';
import { FEEDBACK_RELATIONSHIP_ALIAS } from 'domain/people/employee/Timeline/feedback/form/FeedbackRelationshipDropdown';
import FeedbackForm from 'domain/people/employee/Timeline/feedback/form/FeedbackForm';

interface CreateFeedbackFormProps extends FormTemplateProps {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
}

const CreateFeedbackForm = ({ submitFormFunc, onCancel, ...props }: CreateFeedbackFormProps) => {
  const { getValidationSchema } = useEmployeeFeedbackService();
  return (
    <CreateForm
      submitFormFunc={submitFormFunc}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        relationship: FEEDBACK_RELATIONSHIP_ALIAS.NO_RELATION,
      }}
      {...props}
    >
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <FeedbackForm />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateFeedbackForm;
